import { useMemo } from 'react';
import { CUSTOM_FIELD_ENTITIES } from '@vy/custom-fields-types';
import { CUSTOMER_PREFIX } from '@vy/custom-fields-display';
import { INVOICE_FILTERABLE_FIELDS } from '@vy/types';
import { useCustomFieldDefinitions } from '../../../../hooks/requests/use-custom-field-definitions';
import { useSubsidiaries } from '../../../../hooks/requests/use-subsidiaries';
import type { FilterField } from '../../../../components/new-design/vyTableFilter';
import { createSelectFilterField, INVOICES_FILTER_FIELDS } from './filter-fields-utils';
import { customFieldDefinitionToFilterField } from '../../../../utils/custom-field-filter-utils';

export function useInvoicesFilterFields(): FilterField[] {
  const { data: customFieldDefinitionsData } = useCustomFieldDefinitions();
  const { data: subsidiariesData } = useSubsidiaries();

  return useMemo((): FilterField[] => {
    const allDefinitions = customFieldDefinitionsData?.customFieldDefinitions ?? [];

    const customerFilters: FilterField[] = allDefinitions
      .filter((d) => d.vayuEntity === CUSTOM_FIELD_ENTITIES.CUSTOMER)
      .map((d) =>
        customFieldDefinitionToFilterField(d, `customFieldValues.${CUSTOMER_PREFIX}${d.vayuCustomFieldName}`),
      );

    const invoiceFilters: FilterField[] = allDefinitions
      .filter((d) => d.vayuEntity === CUSTOM_FIELD_ENTITIES.INVOICE)
      .map((d) => customFieldDefinitionToFilterField(d, `customFieldValues.${d.vayuCustomFieldName}`));

    const subsidiaryOptions = (subsidiariesData?.subsidiaries ?? []).map((subsidiary) => ({
      value: subsidiary.id,
      label: subsidiary.name,
    }));

    const subsidiaryField: FilterField | undefined =
      subsidiaryOptions.length === 0
        ? undefined
        : createSelectFilterField(INVOICE_FILTERABLE_FIELDS.INVOICE_SUBSIDIARY_FIELD, 'Subsidiary', subsidiaryOptions);

    return [
      ...INVOICES_FILTER_FIELDS,
      ...(subsidiaryField ? [subsidiaryField] : []),
      ...customerFilters,
      ...invoiceFilters,
    ];
  }, [customFieldDefinitionsData, subsidiariesData]);
}
